import * as React from "react";
import style from "./InstructionLink.module.scss";

const { HIDE_DOCUMENTATION } = process.env;

type Props = {};

const InstructionLink: React.FC<Props> = (props) => {
  const {} = props;

  return (
    <div className={style.container}>
      {!Boolean(HIDE_DOCUMENTATION) && (
        <a href="https://api.myelsa.ru/storage/docs/manual_heating.pdf" target="_blank">Справочная информация</a>
      )}
      <div className={style.info}>ELSA (ООО "Невасофт"), ИНН 7814726620</div>
    </div>
  );
};

export default React.memo(InstructionLink) as typeof InstructionLink;
